import SubpageName from "src/model/SubpageName";

export interface Route {
    title: string,
    href: string,
    name?: SubpageName,
    routes?: Route[],
    separator?: boolean
}

export const routes: Route[] = [
    {
        title: 'Home',
        href: '/',
        name: SubpageName.Home,
    },
    {
        title: 'Banner Config',
        href: '/banner-conf',
        name : SubpageName.PageConfig,
    },
    {
        title: 'Future Fee Config',
        href:'/futurefee',
        name: SubpageName.PageConfig,
    },
    {
        title: 'Fee Explainer Input',
        href: '/fee-explainer-input',
        name: SubpageName.FeeExplainerPortal,
        routes: [
            {
                title: 'Decision Table Config',
                href: '/fee-explainer-input/decision-table-config',
            },
            {
                title: 'Datakey Metadata',
                href: '/fee-explainer-input/datakey-metadata',
            },
            {
                title: 'Fee Type Examples',
                href: '/fee-explainer-input/fee-type-example',
            }
        ]
    },
    {
        title: 'Fee Change Workflow',
        href: '/fee-change-workflow',
        name: SubpageName.FeeChangeWorkflow,
    },
]
